import { LuMail, LuPhone, LuMapPin, LuGlobe, LuGithub, LuLinkedin } from "react-icons/lu";

const ICONS = {
  mail: LuMail,
  phone: LuPhone,
  location: LuMapPin,
  website: LuGlobe,
  github: LuGithub,
  linkedin: LuLinkedin,
};

// Una línea de contacto: icono lineal + texto. Si trae `href` se muestra como
// enlace clicable (mailto/tel/externo); si no, como texto plano. Nunca se
// muestra la URL cruda, sólo la etiqueta.
export default function ContactItem({ icon, label, href }) {
  const Icon = ICONS[icon] || LuGlobe;
  const isExternal = href && /^https?:/i.test(href);

  return (
    <li className="cv-contact-item">
      <Icon className="cv-contact-icon" aria-hidden="true" size={13} />
      {href ? (
        <a
          className="cv-contact-link"
          href={href}
          {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        >
          {label}
        </a>
      ) : (
        <span>{label}</span>
      )}
    </li>
  );
}
